import { action } from 'typesafe-actions';

import { INotification } from '../interfaces/INotification';
import { NoticeActionsEnum } from '../enums/NoticeActionsEnum';

export const addNoticeAction = (notice: INotification) => action(NoticeActionsEnum.ADD_NOTICE, { notice });
export const removeNoticeAction = (id: string) => action(NoticeActionsEnum.REMOVE_NOTICE, { id });
export const removeAllNoticesAction = () => action(NoticeActionsEnum.REMOVE_ALL_NOTICES);
